var map = {
	"./a_button.png": [
		5527
	],
	"./b_button.png": [
		5793
	],
	"./background_desert.png": [
		8613
	],
	"./background_fall.png": [
		1604
	],
	"./background_forest.png": [
		9337
	],
	"./background_grass.png": [
		8746
	],
	"./background_winter.png": [
		1262
	],
	"./crystal.png": [
		1829,
		829
	],
	"./d_pad_button.png": [
		1813
	],
	"./enemy_01.png": [
		4129
	],
	"./enemy_02.png": [
		2202
	],
	"./enemy_03.png": [
		925
	],
	"./heart_empty.png": [
		9568,
		568
	],
	"./heart_full.png": [
		6866,
		866
	],
	"./heart_half.png": [
		9130,
		998
	],
	"./key.png": [
		7986,
		986
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5483;
module.exports = webpackAsyncContext;